import $api from "@/zapi-frontend/shared/api/axios";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";

export function useResendInvitation(
  options?: UseMutationOptions<void, AxiosError<{ message: string }>, { organizationId: number; email: string }>
) {
  return useMutation({
    mutationKey: ["resend-invitation"],
    mutationFn: async ({ organizationId, email }: { organizationId: number; email: string }) => {
      await $api.post(`/organizations/${organizationId}/invites/reinvite`, { email });
    },

    ...options
  });
}
